// FP-7707: mutated in place by setV2ExperienceFlag once the real toggle resolves.
export const V2_EXPERIENCE_FLAG = {
  isV2ExperienceEnabled: false,
};

// `let` so this is a live ESM binding — importers see reassignments below.
export let V2_EVENT_PROPERTY = JSON.stringify(V2_EXPERIENCE_FLAG);

// Call once the real BLUE_GREEN_TEST_MERCHANT value is known (see MerchantProvider).
export const setV2ExperienceFlag = (isEnabled) => {
  V2_EXPERIENCE_FLAG.isV2ExperienceEnabled = Boolean(isEnabled);
  V2_EVENT_PROPERTY = JSON.stringify(V2_EXPERIENCE_FLAG);
};
